import { render } from "./UserGroupUserList.vue?vue&type=template&id=53e52d82&scoped=true"
import script from "./UserGroupUserList.vue?vue&type=script&lang=ts"
export * from "./UserGroupUserList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-53e52d82"

export default script